import { ReactComponent as Icon } from './numericalIcon.svg'
import { theme } from '@ss/meta-core-components'
import React from 'react'
import { config } from '../../../config'

interface Props {
  ariaLabel?: string
  role?: string
}

export const NumericalIcon: React.FC<Props> = ({
  ariaLabel = 'numerical',
  role = 'icon',
}) => {
  return (
    <Icon
      aria-label={ariaLabel}
      role={role}
      data-cy={'numerical-icon'}
      stroke={
        theme.type === 'dark' ? config.iconColorDark : config.iconColorLight
      }
      fill={'none'}
    />
  )
}
